import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { InnerSearchComponent } from './inner-search/inner-search.component';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { HeaderModule } from './header/header.module';
import { FooterModule } from './footer/footer.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ExplorerHeaderModule } from './explorer-header/explorer-header.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    HeaderModule,
    FooterModule,
    ExplorerHeaderModule,
    NgbModule,
    TabsModule.forRoot(),
    BsDropdownModule.forRoot()
  ],
  declarations: [
    InnerSearchComponent,
  ],
  exports: [
    InnerSearchComponent,
  ]
})
export class ComponentsModule { }